/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Table_Created_OnInputs */

const en_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created On`)
};

const fr_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créé le`)
};

const de_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

const it_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato il`)
};

const ru_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано в`)
};

const es_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado el`)
};

const zh_cn2_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

const ja_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const hi_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर बनाया`)
};

const pt_pt2_automatic_save_table_created_on = /** @type {(inputs: Automatic_Save_Table_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

/**
* | output |
* | --- |
* | "Created On" |
*
* @param {Automatic_Save_Table_Created_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_table_created_on = /** @type {((inputs?: Automatic_Save_Table_Created_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Table_Created_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_table_created_on(inputs)
	if (locale === "de") return de_automatic_save_table_created_on(inputs)
	if (locale === "it") return it_automatic_save_table_created_on(inputs)
	if (locale === "ru") return ru_automatic_save_table_created_on(inputs)
	if (locale === "es") return es_automatic_save_table_created_on(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_table_created_on(inputs)
	if (locale === "ja") return ja_automatic_save_table_created_on(inputs)
	if (locale === "hi") return hi_automatic_save_table_created_on(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_table_created_on(inputs)
	return en_automatic_save_table_created_on(inputs)
});